module.exports = __webpack_public_path__ + "static/img/SS.4d38853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SS.png
// module id = vKXz
// module chunks = 34